export const multilang = {
    "hindi": "रिकॉर्ड करते समय पक्का करें कि आप बोल रहे हों",
    "bengali": "অনুগ্রহ করে নিশ্চিত করুন যে আপনি কেবল রেকর্ড করার সময়ই কথা বলছেন",
    "marathi": "कृपया रेकॉर्ड करताना तुम्ही बोलत आहात याची खात्री करा",
    "telugu": "దయచేసి మీరు రికార్డ్ చేస్తున్నప్పుడు మాట్లాడుతున్నారని నిర్ధారించుకోండి",
    "tamil": "பதிவு செய்யப்படும் போது நீங்கள் பேசுவதை உறுதி செய்து கொள்ளவும்",
    "gujarati": "કૃપા કરીને ખાતરી કરો કે તમે રેકોર્ડિંગ દરમિયાન બોલો છો",
    "kannada": "ನಿಮ್ಮ ಧ್ವನಿ ರೆಕಾರ್ಡ್ ಮಾಡುವಾವ ದಯವಿಟ್ಟು ನಿಮ್ಮ ಧ್ವನಿ ಮೇಲೆ ಗಮನವಿರಲಿ",
    "malayalam": "റെക്കോർഡ് ചെയ്യുന്നതിനിടയിൽ നിങ്ങൾ സംസാരിക്കുന്നുവെന്ന് ദയവായി ഉറപ്പു വരുത്തുക",
    "english": "Please make sure you speak while being recorded",
    "punjabi": "ਕਿਰਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਸੀਂ ਰਿਕਾਰਡ ਕੀਤੇ ਜਾਣ ਦੌਰਾਨ ਬੋਲਦੇ ਹੋ",
    "assamese": "অনুগ্ৰহ কৰি ৰেকৰ্ড কৰাৰ সময়ত আপুনি কোৱা নিশ্চিত কৰক",
    "oriya": "ଦୟାକରି ରେକର୍ଡ ହେବା ସମୟରେ ଆପଣ କଥା କହୁଛନ୍ତି ତାହା ନିଶ୍ଚିତ କରନ୍ତୁ",
    "urdu": "براہ کرم اس بات کو یقینی بنائیں کہ آپ ریکارڈ نگ کے دوران بولتے ہیں",
    "bhojpuri": "रिकार्डिंग करत घरी आपन बात जरूर राखीं",
    "manipuri": "ꯆꯥꯅꯕꯤꯗꯨꯅꯥ ꯔꯦꯀꯣꯔꯗ ꯇꯧꯔꯤꯉꯩꯗꯥ ꯋꯥꯔꯤ ꯁꯥꯕꯥ ꯁꯣꯏꯗꯅꯥ ꯇꯧꯕꯤꯌꯨ꯫",
    "maithili": "कृपया रिकॉर्डिंग होइत काल अवश्य बाजब",
}
